import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth } from "@/components/RequireAuth";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import EventDetail from "@/pages/EventDetail";
import MyList from "@/pages/MyList";
import Organize from "@/pages/Organize";
import Admin from "@/pages/Admin";
import Forum from "@/pages/Forum";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Directory from "@/pages/Directory";
import Communities from "@/pages/Communities";
import HostDashboard from "@/pages/HostDashboard";
import { OnboardingModal } from "@/components/OnboardingModal";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/calendar"
        element={
          <RequireAuth label="The full event calendar is for members">
            <Home />
          </RequireAuth>
        }
      />
      <Route
        path="/events/:id"
        element={
          <RequireAuth label="Event details are for members">
            <EventDetail />
          </RequireAuth>
        }
      />
      <Route
        path="/forum"
        element={
          <RequireAuth label="The member forum is private">
            <Forum />
          </RequireAuth>
        }
      />
      <Route
        path="/messages"
        element={
          <RequireAuth label="Direct messages are for members">
            <Messages />
          </RequireAuth>
        }
      />
      <Route
        path="/communities"
        element={
          <RequireAuth label="Community pages are for members">
            <Communities />
          </RequireAuth>
        }
      />
      <Route
        path="/communities/:slug"
        element={
          <RequireAuth label="Community pages are for members">
            <Communities />
          </RequireAuth>
        }
      />
      <Route
        path="/directory"
        element={
          <RequireAuth label="The member directory is private">
            <Directory />
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth label="Member profiles are private">
            <Profile />
          </RequireAuth>
        }
      />
      <Route
        path="/members/:id"
        element={
          <RequireAuth label="Member profiles are private">
            <Profile />
          </RequireAuth>
        }
      />
      <Route path="/dashboard" element={<MyList mode="rsvps" />} />
      <Route path="/saved" element={<MyList mode="saved" />} />
      <Route path="/organize" element={<Organize />} />
      <Route path="/host" element={<HostDashboard />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <OnboardingModal />
        <Toaster position="bottom-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}
